import { createContext, useContext } from 'react';
import type { AuthenticatedUser } from '../../types';

export interface AuthContextValue {
  user: AuthenticatedUser | null;
  needsSetup: boolean;
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth must be used inside AuthProvider');
  return value;
}
